import { useState } from 'react';

import { authClient } from '../lib/auth-client';

export function ResetPassword() {
  const token = new URLSearchParams(window.location.search).get('token');
  const [password, setPassword] = useState('');
  const [message, setMessage] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (!token) return;
    setBusy(true);
    const result = await authClient.resetPassword({ newPassword: password, token });
    setMessage(
      result.error
        ? (result.error.message ?? 'El enlace no es válido o ya expiró.')
        : 'Contraseña actualizada. Ya puedes iniciar sesión.',
    );
    setBusy(false);
  }

  return (
    <main className="relative z-10 mx-auto flex min-h-[80vh] max-w-xl items-center px-5 py-16">
      <section className="glass-panel w-full rounded-[2rem] p-8">
        <p className="eyebrow">Seguridad de cuenta</p>
        <h1 className="mt-2 text-3xl font-bold text-white">Crea una nueva contraseña</h1>
        {!token ? (
          <p className="mt-5 text-sm text-rose-300">Este enlace no contiene un token válido.</p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4">
            <input
              type="password"
              minLength={12}
              maxLength={128}
              required
              autoComplete="new-password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              className="field-input"
              placeholder="Mínimo 12 caracteres"
            />
            {message && (
              <p role="status" className="text-sm text-zinc-300">
                {message}
              </p>
            )}
            <button
              disabled={busy}
              className="w-full rounded-full bg-white px-5 py-3 text-sm font-bold text-zinc-950 disabled:opacity-50"
            >
              {busy ? 'Actualizando…' : 'Guardar contraseña'}
            </button>
          </form>
        )}
      </section>
    </main>
  );
}
